import { Routes } from '@angular/router';

import { LanguageGuard, AuthGuard, LoginGuard } from '@app/guards'

export const routes: Routes = [    
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage),        
        canActivate: [LanguageGuard, LoginGuard]
    },
    {
        path: '',        
        canActivate: [LanguageGuard, AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },    
            {
                path: 'logout',
                loadComponent: () => import('./pages/logout/logout.page').then( m => m.LogoutPage)
            },        
            {
                path: 'home',
                loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage)
            },            
            {
                path: 'stores-directory',
                loadComponent: () => import('./pages/stores-directory/stores-directory.page').then( m => m.StoresDirectoryPage)
            },
            {
                path: 'missions-planning',
                loadComponent: () => import('./pages/missions/planning/planning.page').then( m => m.MissionPlanningPage)
            },
            {
                path: 'quotas',
                loadComponent: () => import('./pages/quotas/quotas.page').then( m => m.QuotasPage)
            },
            {
                path: 'photos-gallery',
                loadComponent: () => import('./pages/photos-gallery/photos-gallery.page').then( m => m.PhotosGalleryPage)
            },
            {
                path: 'mission-add',
                loadComponent: () => import('./pages/missions/add/add.page').then( m => m.MissionAddPage)
            },            
            {
                path: 'reporting',
                loadComponent: () => import('./pages/reporting/reporting.page').then( m => m.ReportingPage)
            },
            {
                path: 'permanent-planning',
                loadComponent: () => import('./pages/permanent/planning/planning.page').then( m => m.PermanentPlanningPage)
            },
            {
                path: 'pre-orders',
                loadComponent: () => import('./pages/pre-orders/pre-orders.page').then( m => m.PreOrdersPage)
            }
        ]
    },
    {
        path: '**',
        redirectTo: '',
    }
  
];
